import { Component,  Input, EventEmitter, Output } from '@angular/core';
import { HEIGHTS } from '../../../../src/app/helpers/helpers';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'toggle-tab',
    template: `
<div class="toggle-tab" [ngStyle]="{height: height}" [ngClass]="{borderless: borderless, bottomTab: bottomTab}">
  <mat-slide-toggle *ngIf="tabLeft && !hideToggle" [disabled]="readOnly" [ngClass]="{selected: toggled}" (change)="toggle.emit()" [checked]="toggled"></mat-slide-toggle>
  <div style="flex:1;" *ngIf="tabLeft && addSpacer"></div>
  <div class="toggle-text" *ngIf="!!text" [ngClass]="{selected: toggled}">{{ text }}</div>
  <div style="flex:1;" *ngIf="!tabLeft && addSpacer"></div>
  <mat-slide-toggle *ngIf="!tabLeft && !hideToggle" [disabled]="readOnly" [ngClass]="{selected: toggled}" (change)="toggle.emit()" [checked]="toggled"></mat-slide-toggle>
</div>
`,
    styleUrls: ['./toggle-tab.scss'],
    standalone: true,
    imports: [MatSlideToggleModule, CommonModule]
})

export class ToggleTabComponent {
  @Input() text = ''
  @Input() tabLeft = false
  @Input() height = HEIGHTS.twenty
  @Input() bottomTab = true
  @Input() borderless = false
  @Input() toggled = false
  @Input() hideToggle = false
  @Input() addSpacer = false
  @Output() toggle: EventEmitter<void> = new EventEmitter();
  @Input() readOnly = false

}
